import React, { memo } from "react";
import { Box, Container, Grid2, Skeleton, Typography } from "@mui/material";
import { ArrowForwardIosOutlined } from "@mui/icons-material";
import { useGetAllStateListQuery } from "../../../../Services/auto-complete.services";
import { useNavigate, Link } from "react-router-dom";
import { RightPaddingWrapper } from "../../../../Components/RightPaddingWrapper/RightPaddingWrapper";
import APP_ROUTES from "../../../../Configurations/APP_ROUTES";

type StateListLinksProps = {};

const StateListLinks = memo((props: StateListLinksProps) => {
  const navigate = useNavigate();

  const { data, isLoading } = useGetAllStateListQuery("");

  if (isLoading) {
    return (
      <Container maxWidth={"xl"} disableGutters>
        <RightPaddingWrapper>
          <Box display={"flex"} alignItems={"center"}>
            <Skeleton animation="wave" variant="text" width={350} height={32} />
          </Box>
          <Grid2 container columnSpacing={{ xs: 1, sm: 2 }} rowSpacing={{ xs: 1, sm: 1.5 }} mt={{ xs: 4, md: 8 }}>
            {Array.from(new Array(30)).map((v: any, i: any) => (
              <Grid2
                key={i}
                size={{
                  xl: 12 / 5,
                  lg: 12 / 5,
                  md: 12 / 3,
                  sm: 12 / 2,
                  xs: 6,
                }}
              >
                <Box>
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width="70%"
                    height={24}
                    sx={{ my: 0.5 }}
                  />
                </Box>
              </Grid2>
            ))}
          </Grid2>
        </RightPaddingWrapper>
      </Container>
    );
  }

  return (
    <Container maxWidth={"xl"} disableGutters>
      <RightPaddingWrapper>
        <Box display={"flex"} alignItems={"center"}>
          <Typography variant="h6" fontWeight={600}>
            Search for homes by state &nbsp;|&nbsp; {"  "}
            <Typography
              sx={{
                display: "inline-flex",
                alignItems: "center",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                }
              }}
              component={Link}
              to={String(APP_ROUTES.BROWSE_STATES.pathname)}
              fontWeight={"700"}
              variant="h6"
              color="primary.main"
            >
              View full list
              <ArrowForwardIosOutlined sx={{ fontSize: 15, marginLeft: 2 }} />
            </Typography>{" "}
          </Typography>
        </Box>
        <Grid2 container columnSpacing={{ xs: 1, sm: 2 }} rowSpacing={{ xs: 1, sm: 1.5 }} mt={{ xs: 4, md: 8 }}>
          {data?.data?.result.slice(0, 30).map((v: any, i: any) => {
            return (
              <Grid2
                key={i}
                size={{
                  xl: 12 / 5,
                  lg: 12 / 5,
                  md: 12 / 3,
                  sm: 12 / 2,
                  xs: 6,
                }}
              >
                <Box>
                  <Typography
                    variant="subtitle1"
                    color="primary"
                    component={"a"}
                    lineHeight={1}
                    sx={{
                      textDecoration: "none",
                      cursor: "pointer",
                      fontSize: { xs: "0.85rem", sm: "1rem" },
                    }}
                    onClick={() => {
                      navigate(`${v.stateID}/state/${v?.state}`);
                    }}
                  >
                    {v?.stateName} real estate
                  </Typography>
                </Box>
              </Grid2>
            );
          })}
        </Grid2>
      </RightPaddingWrapper>
    </Container>
  );
});

export default StateListLinks;
